module.exports = __webpack_public_path__ + "img/ba.32231661.svg";